import { Link } from "react-router-dom";
import React, { Component } from "react";
import {
  Button,
  Card as Cd,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
import { Storage } from "aws-amplify";
import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";
import Chip from "@material-ui/core/Chip";
import withStyles from "@material-ui/core/styles/withStyles";
import gql from "graphql-tag";
import { getInspector } from "../graphql/queries";
import { connect } from "react-redux";
Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
var self = null;
const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};
class ViewInspector extends Component {
  constructor(props) {
    super(props);
    self = this;
    this.state = {
      fName: "",
      lName: "",
      email: "",
      password: "",
      cPassword: "",
      address: "",
      city: "",
      st: "",
      phoneNum: "",
      date: "",
      skills: [],
      qualifications: [],
      experiences: []
    };
  }
  async componentDidMount() {
    const { client, user } = this.props;
    const inspector = await client.query({
      query: gql(getInspector),
      fetchPolicy: `network-only`,
      variables: { id: this.props.match.params.iId }
    });
    let obj = inspector.data.getInspector;
    this.setState({
      fName: obj.name,
      email: obj.email,
      password: "",
      cPassword: "",
      address: obj.homeAddress,
      city: obj.city,
      st: obj.state,
      phoneNum: obj.phoneNo,
      date: obj.registrationDate,
      skills: obj.skills,
      qualifications: obj.qualifications,
      experiences: obj.employmentHistory
    });
  }
  downloadFile = async key => {
    alert("starting download");
    Storage.get(key)
      .then(result => {
        window.open(result);
      })
      .catch(err =>{});
  };
  cancelForm = e => {
    //this.props.location.loadData();
    this.props.history.push("../../inspector");
  };
  onInputChange = event => {};
  render() {
    const { classes } = this.props;
    return (
      <div>
        <main ref="main" App>
          <section className="section section-shaped section-lg">
            <Container className="pt-lg-sm pt-2">
              <Row className="justify-content-center">
                <Col lg="10">
                  <Card>
                    <CardHeader color="primary">
                      <h4 className={classes.cardTitleWhite}>View Profile</h4>
                      <p className={classes.cardCategoryWhite}>
                        See Information Below
                      </p>
                    </CardHeader>
                    <CardBody>
                      <Form onSubmit={this.handleSubmit} role="form">
                        <div>
                          <Row form style={{ marginTop: "20px" }}>
                            {/* <Col md={6}> */}
                            <Col>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="fName"
                                    onChange={this.onInputChange}
                                    placeholder="Name"
                                    type="text"
                                    value={this.state.fName}
                                    disabled
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            {/* <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="lName"
                                    onChange={this.onInputChange}
                                    placeholder="Last Name"
                                    type="text"
                                    value={this.state.lName}
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col> */}
                          </Row>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="email"
                                onChange={this.onInputChange}
                                placeholder="Email"
                                type="email"
                                disabled
                                value={this.state.email}
                              />
                            </InputGroup>
                          </FormGroup>

                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-3">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText></InputGroupText>
                              </InputGroupAddon>
                              <Input
                                id="address"
                                onChange={this.onInputChange}
                                placeholder="Address"
                                type="text"
                                value={this.state.address}
                                disabled
                              />
                            </InputGroup>
                          </FormGroup>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="city"
                                    onChange={this.onInputChange}
                                    placeholder="City"
                                    type="text"
                                    value={this.state.city}
                                    disabled
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="st"
                                    onChange={this.onInputChange}
                                    placeholder="State"
                                    type="text"
                                    value={this.state.st}
                                    disabled
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="phoneNum"
                                    onChange={this.onInputChange}
                                    placeholder=" Phone No"
                                    type="tel"
                                    disabled
                                    value={this.state.phoneNum}
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <InputGroup className="input-group-alternative mb-3">
                                  <InputGroupAddon addonType="prepend">
                                    <InputGroupText></InputGroupText>
                                  </InputGroupAddon>
                                  <Input
                                    id="date"
                                    placeholder="Inspection Since"
                                    type="text"
                                    onChange={this.onInputChange}
                                    value={this.state.date}
                                    disabled
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                        </div>
                        <Cd style={{ marginTop: "10px" }}>
                          <CardHeader>
                            <h3>Employment History</h3>
                          </CardHeader>
                          <CardBody>
                            {this.state.experiences !==null && this.state.experiences.length !== 0 &&
                              this.state.experiences.map((item, key) => {
                                return (
                                  <div>
                                    <h5 style={{ color: "black" }}>
                                      {item.jobTitle}
                                    </h5>
                                    <div class="row">
                                      <div class="col-4">
                                        <p>Company:{" " + item.company}</p>
                                      </div>
                                    </div>
                                    <hr />
                                  </div>
                                );
                              }, this)}
                          </CardBody>
                        </Cd>
                        <Cd style={{ marginTop: "10px" }}>
                          <CardHeader>
                            <h3>Qualifications</h3>
                          </CardHeader>
                          <CardBody>
                            {this.state.qualifications!==null && this.state.qualifications.length !== 0 &&
                              this.state.qualifications.map((item, key) => {
                                return (
                                  <div>
                                    <div class="row">
                                      <div class="col-4">
                                        <h5>{item.title}</h5>
                                      </div>
                                      <div class="col-6">
                                        <div>
                                          {item.attachment !== null ? (
                                            <p>
                                              File Uploaded{"  "}
                                              <input
                                                type="button"
                                                style={{ marginLeft: 10 }}
                                                value="download"
                                                onClick={() =>
                                                  this.downloadFile(
                                                    item.attachment.key
                                                  )
                                                }
                                              />
                                            </p>
                                          ) : (
                                            <p>No File Uploaded</p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <hr />
                                  </div>
                                );
                              }, this)}
                          </CardBody>
                        </Cd>
                        <Cd style={{ marginTop: "10px" }}>
                          <CardHeader>
                            <h3>Skills</h3>
                          </CardHeader>
                          <CardBody>
                            {this.state.skills !== null &&
                              this.state.skills.length !== 0 &&
                              this.state.skills.map((item, key) => {
                                return (
                                  <Chip
                                    key={key}
                                    label={item}
                                    style={{ margin: 5 }}
                                  />
                                );
                              }, this)}
                          </CardBody>
                        </Cd>
                          <Row lg="12" className="px-3 ">
                            <Col></Col>
                            <Col>
                              <Button
                                className=" btn-lg btn-block mt-2"
                                color="default"
                                onClick={this.cancelForm}
                              >
                                Back
                              </Button>
                            </Col>
                            <Col></Col>
                          </Row>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client
  };
};
export default ViewInspector = connect(
  mapStateToProps,
  null
)(withStyles(styles)(ViewInspector));



// WEBPACK FOOTER //
// ./src/admin/ViewInspector.jsx